export type TabsListItem = {
  label: string;
  value: string;
};

export type RepairListItem = {
  id: string;
  title: string;
  createTime: string;
  status: string;
};

export type repairStatusMapType = {
  text?: string;
  textColor?: string;
  backGroundColor?: string;
  icon?: any;
};

export type RepairDetailItemType = {
  status: string;
  content: string;
  imgUrl: string;
  backReason: string;
  backTime: string;
  address: string;
  id: string;
};

export const repairDetailItem: RepairDetailItemType = {
  status: 'finish',
  content:
    '我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修我要报修',
  imgUrl: require('@/assets/user/defaultImage.png'),
  backReason: '测试',
  backTime: '2024-09-19 12:00',
  address: '天津市',
  id: '1',
};

export const tabsList: Array<TabsListItem> = [
  {
    label: '全部',
    value: 'all',
  },
  {
    label: '待审核',
    value: 'review',
  },
  {
    label: '处理中',
    value: 'progress',
  },
  {
    label: '被退回',
    value: 'back',
  },
  {
    label: '已完成',
    value: 'finish',
  },
  {
    label: '已撤销',
    value: 'revoke',
  },
  {
    label: '已关闭',
    value: 'cancel',
  },
];

export const repairList: Array<RepairListItem> = [
  {
    id: '1',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'review',
  },
  {
    id: '2',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'progress',
  },
  {
    id: '3',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'back',
  },
  {
    id: '4',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'finish',
  },
  {
    id: '5',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'revoke',
  },
  {
    id: '6',
    title: '保修',
    createTime: '2023-04-01 14:14',
    status: 'cancel',
  },
];

export const repairStatusMap: Record<string, repairStatusMapType> = {
  review: {
    text: '待审核',
    textColor: '#0B2FFF',
    backGroundColor: 'rgba(11, 47, 255, 0.10)',
    icon: require('@/assets/repair/check.png'),
  },
  progress: {
    text: '处理中',
    textColor: '#9221E5',
    backGroundColor: 'rgba(146, 33, 229, 0.10)',
    icon: require('@/assets/repair/process.png'),
  },
  back: {
    text: '被退回',
    textColor: '#0F9C5A',
    backGroundColor: 'rgba(15, 156, 90, 0.10)',
    icon: require('@/assets/repair/back.png'),
  },
  finish: {
    text: '已完成',
    textColor: '#3015DE',
    backGroundColor: 'rgba(48, 21, 222, 0.10)',
    icon: require('@/assets/repair/success.png'),
  },
  revoke: {
    text: '已撤销',
    textColor: '#FB1C1C',
    backGroundColor: 'rgba(251, 28, 28, 0.10)',
    icon: require('@/assets/repair/cancel.png'),
  },
  cancel: {
    text: '已关闭',
    textColor: '#F98026',
    backGroundColor: 'rgba(249, 128, 38, 0.10)',
    icon: require('@/assets/repair/close.png'),
  },
};

export const enum repairStatusEnum {
  REVIEW = 'review',
  PROGRESS = 'progress',
  BACK = 'back',
  FINISH = 'finish',
  REVOKE = 'revoke',
  CANCEL = 'cancel',
}
